import jQuery from 'jquery';
import jQueryUi from 'jquery-ui';

export default jQuery.widget('ep.epform', {
	options: {
		selectors: {
			submitButton: '.button.btn-primary',
			form: 'form'
		},
		onSubmitListener: function(event){}
	},
	_create: function(){
		const selectors = this.options.selectors;
		
		const element = this.element;
		this._submitButton = element.find(selectors.submitButton);
		
		const formSelector = selectors.form;
		const formElm = (formSelector.length === 0)?element:element.find(formSelector);
		this._formElm = formElm;
		
		this._on(formElm, {
			submit: '_onSubmit'
		});
	},
	_onSubmit: function(event){
		const submitButton = this._submitButton;
		
		const isDisabled = submitButton.attr("disabled");
		if(isDisabled){
			event.preventDefault();
		}else{
			setTimeout(function(){
				submitButton.attr("disabled", true);
			})
			this.options.onSubmitListener.apply(this._formElm, [event]);
		}
	}
});